import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  label: {
    marginLeft: '-5px',
    fontSize: theme.typography.fontSize,
    fontFamily: theme.typography.fontFamily,
    fontColor: theme.palette.grey['800'],
  },
})

export default useStyles
